<template>
  <nav
    v-if="totalPages > 1"
    class="m-pagination"
    :aria-label="$t('pagination.label')"
  >
    <button
      type="button"
      class="a-btn a-btn--reversed m-pagination__btn"
      :disabled="1 === modelValue"
      @click="goToPage(modelValue-1)"
    >
      <svg class="a-btn__icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-arrow-left'" />
      </svg>
      <span class="a-btn__label" v-text="$t('pagination.previous')"></span>
    </button>

    <ul class="m-pagination__list">
      <li
        class="m-pagination__list-item"
        :class="{ 'is-active': modelValue === 1 }"
      >
        <button
          class="m-pagination__list-link"
          type="button"
          @click="goToPage(1)"
          :aria-current="modelValue === 1 ? 'step' : false"
          :aria-label="$t('page', { number: 1 })">
          1
        </button>
      </li>

      <template v-for="index in totalPages" :key="index">
        <li
          v-if="validateBeginDots(index)"
          class="m-pagination__list-item"
          aria-hidden="true"
        >
          <span class="m-pagination__list-fill">...</span>
        </li>
        <li
          v-if="validatePagination(index)"
          class="m-pagination__list-item"
          :class="{ 'is-active': modelValue === index }"
        >
          <button
            class="m-pagination__list-link"
            type="button"
            @click="goToPage(index)"
            :aria-current="modelValue === index ? 'step' : 'false'"
            :aria-label="$t('page', { number: index })"
          >
            {{ index }}
          </button>
        </li>
        <li
          v-if="validateEndDots(index)"
          class="m-pagination__list-item"
          aria-hidden="true"
        >
          <span class="m-pagination__list-fill">...</span>
        </li>
      </template>

      <li
        class="m-pagination__list-item"
        :class="{ 'is-active': modelValue === totalPages }"
      >
        <button
          class="m-pagination__list-link"
          type="button"
          @click="goToPage(totalPages)"
          :aria-current="modelValue === totalPages ? 'step' : 'false'"
          :aria-label="$t('page', { number: totalPages })"
          v-text="totalPages"
        >
        </button>
      </li>
    </ul>

    <button
      type="button"
      class="a-btn m-pagination__btn"
      :disabled="totalPages === modelValue"
      @click="goToPage(modelValue+1)"
    >
      <span class="a-btn__label" v-text="$t('pagination.next')"></span>
      <svg class="a-btn__icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-arrow-right'" />
      </svg>
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Number,
      required: true,
    },
  },

  methods: {
    goToPage(page) {
      this.$emit('update:modelValue', page)
    },

    validateBeginDots(page) {
      return (
        this.modelValue > 3 &&
        (this.modelValue === this.totalPages
          ? page === this.modelValue - 3
          : page === this.modelValue - 2)
      )
    },

    validatePagination(page) {
      return (
        page !== 1 &&
        page !== this.totalPages &&
        (this.modelValue === 1
          ? this.modelValue + 3 > page
          : this.modelValue + 2 > page) &&
        (this.modelValue === this.totalPages
          ? this.modelValue - 3 < page
          : this.modelValue - 2 < page)
      )
    },

    validateEndDots(page) {
      return (
        this.modelValue < this.totalPages &&
        this.modelValue + 2 !== this.totalPages &&
        (this.modelValue === 1
          ? page === this.modelValue + 3
          : page === this.modelValue + 2)
      )
    },
  },
}
</script>
